import { useLanguage } from "../../../../contexts/LanguageContext"

/**
 * FAQ section component.
 * Renders the FAQ section with icon, customizable label, and FAQ content.
 * @param {Object} props
 * @param {Object} props.parameters - Configuration parameters containing FAQ label
 * @returns {JSX.Element}
 */
export default function FaqSection({ parameters }) {
  const { t } = useLanguage()

  return (
    <div className="welcomeLineDiv welcomeFaq">
      <span id="mainPopupFaqFile" data-testid="mainPopupFaqFile" className="btn shortwaysIcon faqIcon" />
      <span id="faqLabel" className="welcomeTitle">
        {parameters.faqLabel || t("Text.textFaqInput")}
      </span>
      <div className="categoryTitle">
        <div className="welcomeLineDiv">
          <div className="shortwaysDocList">
            <div className="shortwaysCategory">
              <div className="categoryTitle" aria-controls="shortwaysFaq0" aria-expanded="false">
                {t("AssistantWindow.assistantWindowFaqMisc")}
                <span className="listToggleIcon " />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
